import DropViewState from 'owa-dnd/lib/store/schema/DropViewState';
import getStore from '../store/store';

export default function getDropState(): DropViewState {
    return getStore().dropViewState;
}
